import axios from 'axios';
import { SellerDescription } from '../models/SellerDescription';
import { Collection } from '../models/Collection';

export async function fetchSellerDescription(href: string) {
  const items = (await axios.get<Collection<SellerDescription>>(href)).data.items;
  return items.length > 0 ? items[0] : undefined;
}
